import {apiConfig} from "./apiConfig";
import {dateDisplay} from "./dateDisplay";
import {daysInMonth} from "./daysInMonth";
export const animation = {
    loaderFlag:false,
    modalFlag:false
}
export const slotIn = {
    slotIndex:undefined as any
}
export const slotsDate: {
    slotsByDate:any
} = {slotsByDate:[]}

let apiCall:any = 1;

export function refreshScheduleData(year:any, month:any) {
    slotsDate.slotsByDate = [];
    var isEstimate = localStorage.getItem("selectedAboutHome") == "recurring" ? "true" : "false"
    var isSchedule = window.objOSGlobal.requestBodyValues.ConceptId == 1 ? "&IsEstimate="+isEstimate : "";
    var webLocationId = window.objOSGlobal.requestBodyValues.WebLocationId;
    var serviceSkuId = window.objOSGlobal.requestBodyValues.serviceSkuId
    var getZipCode = localStorage.getItem('zipcode');
    var zipCode = getZipCode.length == 6 ? getZipCode.replace(/^(.{3})(.*)$/, "$1 $2") : getZipCode;
    var date = new Date();
    var today:any = new Date();
    date = new Date(date.getFullYear(), date.getMonth(), 1);
    var numberOfDays = 31;
    var dd:any = today.getDate();
    var mm:any = today.getMonth()+1; 
    var yyyy = today.getFullYear();
    if(dd<10){dd='0'+dd;}
    if(mm<10){mm='0'+mm;} 
    today = mm+'/'+dd+'/'+yyyy;
    if (year == date.getFullYear() && month == (date.getMonth() + 1)) {
        numberOfDays = daysInMonth(month, year);
     } else {
        numberOfDays = daysInMonth(month, year);
     }
     $('.modal-header-one').hide();
     $('.progress, .progressbar').show();
     $('.modal-header-two').css('display', "flex");
        $.ajax({
                url: apiConfig.techAvailability + '?PostalCode='+zipCode+'&WebLocationId='+webLocationId+'&NumberOfDays='+numberOfDays+'&ServiceSkuId='+serviceSkuId+'&DateStart='+today+isSchedule+'&apikey='+window.DEFINE_VALUE.JS_API_KEY,
                type: "GET",
                contentType: "application/json",
                dataType: 'json',
                success: function (results) {
                    localStorage.setItem("scheduleData", JSON.stringify(results));
                    if (results.resultCollection.length > 0) {
                        var currentIndex = results.resultCollection.find((itm:any)=>itm.isAvailable);
                    }
                    if(currentIndex){
                    var resultData = JSON.parse(localStorage.getItem('scheduleData'));
                    resultData.resultCollection.forEach((element:any) => {
                        var date = element.startDate.split('T')[0]
                        var item = slotsDate.slotsByDate.find((itm:any)=>itm.date==date);
                        if(!item){
                           item = {date,slots:[]}
                           slotsDate.slotsByDate.push(item);
                        }
                        item.slots.push(element)
                    });
                    slotIn.slotIndex = slotsDate.slotsByDate.findIndex((itm:any)=>itm.date==currentIndex.startDate.split('T')[0]);
                    dateDisplay(slotIn.slotIndex);
                    }else{
                        $('.tab-pane.fieldset').removeClass('active');
                        $('#steptwo').addClass('active');
                        $('#steptwo .head-title.primary-theme-clr').text('Please call us and we’ll help you find a time that works for you.');
                        $('.progress, .progressbar').hide();
                        $('.modal-header-two').hide();
                        $('.modal-header-one').show();
                        $("#no-search-result").addClass('active');
                    }
                    
                },
                error: function (data, status, error) {
                    localStorage.removeItem("scheduleData");
                    if(apiCall< 2){
                      refreshScheduleData(new Date().getFullYear(), new Date().getMonth() + 1);
                      apiCall++;
                    }else{
                       if(status === "error"){
                        animation.modalFlag = true;
                        $('.tab-pane.fieldset').removeClass('active');
                        $("#no-search-result").addClass('active');
                        $('.progress, .progressbar').hide();
                        $('.modal-header-two').hide();
                        $('.modal-header-one').show();
                        $('.result-stack-logo').hide();
                        $('#no-search-result .head-title').text('Due to a system error, we didn’t receive the form you sent. Please try again later');
                        apiCall = 1; 
                       }
                    }
                }
            });

    //USER STORY 76501
    if($('#conceptCode').val() == "MLY") {
        var frequency = "";
        if ($("#inputOneTime").is(":checked")) 
            frequency = "onetime";
        else
            frequency = "recurring";
        
        var brands = window.objOSGlobal.requestBodyValues.Country == 'CA' ? "/ca/en-ca/_assets/brands.json" : "/us/en-us/_assets/brands.json";
        
        $.getJSON(brands, function (result:any) { 
            if (result.length > 0) {
                var items = $.grep(result, function (e:any) { return e.code === $('#conceptCode').val() });
                
                if(items.length) {
                    
                    var title = frequency == "recurring" ? items[0].schedule_title_recurring : items[0].schedule_title_onetime;
                    var subtitle = frequency == "recurring" ? items[0].schedule_subtitle_recurring : items[0].schedule_subtitle_onetime;
                    
                    $('#step3 .fieldset-title').text(title);
                    $('#step3 .sub-heading').text(subtitle);				
                }
            }
        });
    }
}
